import {
    CONNECTIVITY_ERROR,
    CREATE_SYNC_SCHEDULE,
    FETCH_CONNECTIVITY_REQUEST,
    FILTER_PRACTICE_RELATIONS,
    GET_ALL_IGNORED_ERRORS,
    GET_CONNECTIVITY,
    GET_INSTANCE_FORM,
    GET_SCHEDULES,
    GET_STATES,
    NEW_CONNECITON_SELECTED_PRACTICE,
    NEW_CONNECTION_SELECTED_PARTNER,
    NEW_REQUEST_FORM_DISABLED,
    PUT_IGNORED_ERRORS,
    SET_SCHEDULE_EDIT_INDEX,
    STORE_RRULE,
    UPDATE_SCHEDULE_LIST,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();
    const getAllStates = (states) => {
        return {
            type: GET_STATES,
            payload: states,
        };
    };

    const createSyncSchedule = (schedule) => {
        return {
            type: CREATE_SYNC_SCHEDULE,
            payload: schedule,
        };
    };

    const setNewRequestFormDisableStatus = (status) => {
        return {
            type: NEW_REQUEST_FORM_DISABLED,
            payload: status,
        };
    };

    const fetchConnectivityRequest = () => {
        return {
            type: FETCH_CONNECTIVITY_REQUEST,
        };
    };

    const getConnectivity = (connectivity) => {
        return {
            type: GET_CONNECTIVITY,
            payload: connectivity,
        };
    };

    const connectivityError = (error) => {
        return {
            type: CONNECTIVITY_ERROR,
            payload: error,
        };
    };

    const updateSchedules = (schedules) => {
        return {
            type: UPDATE_SCHEDULE_LIST,
            payload: schedules,
        };
    };

    const setScheduleEditIndex = (index) => {
        return {
            type: SET_SCHEDULE_EDIT_INDEX,
            payload: {
                index: index,
            },
        };
    };

    const filterConnectivity = (connectivity) => {
        return {
            type: FILTER_PRACTICE_RELATIONS,
            payload: connectivity,
        };
    };

    const setSelectedPartnerPractice = (selected, action) => {
        if (action === 'partner') {
            return {
                type: NEW_CONNECTION_SELECTED_PARTNER,
                payload: selected,
            };
        } else {
            return {
                type: NEW_CONNECITON_SELECTED_PRACTICE,
                payload: selected,
            };
        }
    };

    const getSchedules = (schedules) => {
        return {
            type: GET_SCHEDULES,
            payload: schedules,
        };
    };

    const storeUpdatedRRule = (rrule) => {
        return {
            type: STORE_RRULE,
            payload: rrule,
        };
    };

    const getInstanceForm = (instanceForm) => {
        return {
            type: GET_INSTANCE_FORM,
            payload: instanceForm,
        };
    };

    const saveEditedSyncSchedule = (newRRule, id) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(`connectivity/` + id, {
                    rrule: newRRule,
                });
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };
    const fetchPartnerPractices = (partnerID) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(
                    `connectivity?partner=` + partnerID
                );
                const connectivity = response.data;
                dispatch(filterConnectivity(connectivity));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };

    // const fetchSchedule = (practiceId) => {
    //   return async (dispatch) => {
    //     try {
    //       dispatch(fetchConnectivityRequest);
    //       var response = await axiosCall.get(`Practices/${practiceId}/schedules`);
    //       const schedules = response.data.data;
    //       dispatch(getSchedules(schedules));
    //       dispatch(fetchEmptyInstanceForm());

    //     }
    //     catch (error) {
    //       const errorMsg = error.message;
    //       dispatch(connectivityError(errorMsg));
    //     }
    //   }
    // };

    const postSchedule = (practiceId, newSchedule) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post(
                    `Practices/${practiceId}/schedules`,
                    newSchedule
                );
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };

    const patchSchedule = (practiceId, scheduleId, newSchedule) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(
                    `Practices/${practiceId}/schedules/${scheduleId}`,
                    newSchedule
                );
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };

    const fetchEmptyInstanceForm = () => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(`Practices/instances/empty`);
                const instanceForm = response.data.data;
                dispatch(getInstanceForm(instanceForm));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };

    const updateConnectivity = (id, connectivity) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(`connectivity/` + id, {
                    pims: connectivity.pims,
                    date: connectivity.date,
                    interval: parseInt(connectivity.interval, 10),
                });
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };
    const saveConfiguration = (configuration) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(
                    `connectivity/` + configuration.id,
                    configuration
                );
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };

    const createNewRequest = (request) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post(`requests/`, request);
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };

    const fetchAllStates = () => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(`states/`);
                dispatch(getAllStates(response.data));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };

    const fetchAllIgnoredErrors = () => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(
                    `http://localhost:3004/ignoredErrors/`
                );
                dispatch(getAllIgnoredErrors(response.data));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };

    const getAllIgnoredErrors = (ignoredErrors) => {
        return {
            type: GET_ALL_IGNORED_ERRORS,
            payload: ignoredErrors,
        };
    };

    const deleteIgnoredError = (ignoredError) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.delete(
                    `http://localhost:3004/ignoredErrors/` + ignoredError.id
                );
                dispatch(getAllIgnoredErrors);
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };

    const addIgnoredError = (ignoredError) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post(
                    `http://localhost:3004/ignoredErrors/`,
                    ignoredError
                );
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(connectivityError(errorMsg));
            }
        };
    };

    const putIgnoredErrors = (ignoredErrors) => {
        return {
            payload: ignoredErrors,
            type: PUT_IGNORED_ERRORS,
        };
    };

    return {
        getAllStates,
        createSyncSchedule,
        setNewRequestFormDisableStatus,
        fetchConnectivityRequest,
        getConnectivity,
        connectivityError,
        updateSchedules,
        setScheduleEditIndex,
        filterConnectivity,
        setSelectedPartnerPractice,
        getSchedules,
        storeUpdatedRRule,
        getInstanceForm,
        saveEditedSyncSchedule,
        fetchPartnerPractices,
        postSchedule,
        patchSchedule,
        fetchEmptyInstanceForm,
        updateConnectivity,
        saveConfiguration,
        createNewRequest,
        fetchAllStates,
        fetchAllIgnoredErrors,
        getAllIgnoredErrors,
        deleteIgnoredError,
        addIgnoredError,
        putIgnoredErrors,
    };
};

export default initActions;
